// AnalyzeScreen by id

import { View, TouchableOpacity, Platform } from "react-native"
import SubjectPropertyScreen from "@/screens/SubjectPropertyScreen"
import { GestureHandlerRootView } from "react-native-gesture-handler"
import { router, useFocusEffect, useLocalSearchParams } from "expo-router"
import BackButton from "@/assets/icons/back-arrow-white.svg"
import BackButtonDark from "@/assets/icons/back-arrow-dark.svg"
import { $selectedCompDetailId } from "@/stores/compsDataStore"
import { useBottomSheetModal } from "@gorhom/bottom-sheet"
import { useState } from "react"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { cn } from "@/components/util/cn"

export default function AnalyzeScreen() {
  const insets = useSafeAreaInsets()
  const { analysisId: paramAnalysisId } = useLocalSearchParams()
  const [isDarkBackButton, setIsDarkBackButton] = useState(false)
  const analysisId = Array.isArray(paramAnalysisId)
    ? paramAnalysisId[0]
    : paramAnalysisId
  const { dismissAll } = useBottomSheetModal()

  useFocusEffect(() => {
    dismissAll()
    $selectedCompDetailId.set(null)
  })

  const handleBackButtonChange = (isDark: boolean) => {
    setIsDarkBackButton(isDark)
  }

  const backBtnTop = Platform.select({
    android: "top-[24px]",
    ios: "top-[12px]",
    web: "top-[52px]",
  })

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <View
        testID="AnalyzeScreen"
        className="flex flex-1 items-center justify-center bg-off-white"
      >
        <SubjectPropertyScreen
          analysisId={analysisId}
          onBackButtonChange={handleBackButtonChange}
        />
        <TouchableOpacity
          style={{ paddingTop: insets.top, zIndex: 999 }}
          testID={"back-button"}
          hitSlop={16}
          className={cn("absolute left-6", backBtnTop)}
          onPress={() => {
            // TODO hack to force properties list in all cases
            router.replace("/properties")
          }}
        >
          {isDarkBackButton ? (
            <BackButtonDark width={22} height={14} />
          ) : (
            <BackButton width={22} height={14} />
          )}
        </TouchableOpacity>
      </View>
    </GestureHandlerRootView>
  )
}
